import React from 'react'

import { Modal, Button, Row, Col } from '_zari/core'

import * as Sections from './sections'

const TIPOS_DOCUMENTO = [
  { value: '01', label: '01 - Factura' },
  { value: '03', label: '03 - Boleta' }
]

const HistorialVentasModal = ({ handleClose, show, mainFormData, onDocumentoSeleccionado }) => {
  const [documentoInfo, setDocumentoInfo] = React.useState(null)
  const [modoManual, setModoManual] = React.useState(false)
  const [datosManual, setDatosManual] = React.useState({
    tipoDocumento: '01',
    serieDocumento: '',
    numeroDocumento: '',
    fechaDocumento: ''
  })

  const clickSeleccionarDocumentoClick = React.useCallback(row => {
    setDocumentoInfo(row)
  }, [])

  const handleManualChange = React.useCallback(e => {
    const { name, value } = e.target
    setDatosManual(prev => ({ ...prev, [name]: value }))
  }, [])

  const handleToggleManual = React.useCallback(e => {
    const checked = e.target.checked
    setModoManual(checked)
    if (!checked) {
      setDatosManual({ tipoDocumento: '01', serieDocumento: '', numeroDocumento: '', fechaDocumento: '' })
    }
  }, [])

  const datosManualValidos = React.useMemo(() => {
    return (
      datosManual.serieDocumento.trim() !== '' &&
      datosManual.numeroDocumento.trim() !== '' &&
      datosManual.fechaDocumento.trim() !== ''
    )
  }, [datosManual])

  const handleSubmit = React.useCallback(() => {
    if (modoManual) {
      // <input type='date'> devuelve ISO 'yyyy-MM-dd'; backend espera 'dd/MM/yyyy'.
      // Sin esta conversión parseToDate falla → epoch 0 → 31/12/1969 en BD.
      const [anio, mes, dia] = (datosManual.fechaDocumento || '').split('-')
      const fechaPrincipalFormateada = anio && mes && dia ? `${dia}/${mes}/${anio}` : ''

      mainFormData._idDocumentoRelacionado = null
      mainFormData._idDocumentoNota = null
      mainFormData.modificadoTipoDocumento = datosManual.tipoDocumento
      mainFormData.modificadoSerieDocumento = datosManual.serieDocumento.toUpperCase()
      mainFormData.modificadoNumeroDocumento = datosManual.numeroDocumento
      mainFormData.fechaDocumentoPrincipal = fechaPrincipalFormateada
      mainFormData.documentoManual = true
    } else {
      mainFormData._idDocumentoRelacionado = documentoInfo._id
      mainFormData._idDocumentoNota = documentoInfo._id
      mainFormData.modificadoTipoDocumento = documentoInfo.tipoDocumento
      mainFormData.modificadoSerieDocumento = documentoInfo.serieDocumento
      mainFormData.modificadoNumeroDocumento = documentoInfo.numeroDocumento
      mainFormData.documentoManual = false
    }

    onDocumentoSeleccionado({ ...mainFormData })
    handleClose()
  }, [mainFormData, documentoInfo, datosManual, modoManual, onDocumentoSeleccionado, handleClose])

  const puedeGuardar = modoManual ? datosManualValidos : documentoInfo !== null

  const handleVolver = React.useCallback(() => {
    setDocumentoInfo(null)
  }, [])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>CONSULTAR DOCUMENTO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!documentoInfo && (
          <div className='mb-3'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                id='modo-manual-switch'
                checked={modoManual}
                onChange={handleToggleManual}
              />
              <label className='form-check-label' htmlFor='modo-manual-switch'>
                Ingresar datos manualmente (documento histórico)
              </label>
            </div>
            <hr />
          </div>
        )}

        {modoManual ? (
          <div style={{ padding: '16px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f9f9f9' }}>
            <p style={{ color: '#666', fontSize: '13px', marginBottom: '16px' }}>
              Use esta opción para referenciar comprobantes que no aparecen en la búsqueda.
            </p>
            <Row>
              <Col md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label'>Tipo Documento</label>
                  <select
                    className='form-control'
                    name='tipoDocumento'
                    value={datosManual.tipoDocumento}
                    onChange={handleManualChange}
                  >
                    {TIPOS_DOCUMENTO.map(tipo => (
                      <option key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label'>Fecha del Documento</label>
                  <input
                    type='date'
                    className='form-control'
                    name='fechaDocumento'
                    value={datosManual.fechaDocumento}
                    onChange={handleManualChange}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label'>Serie</label>
                  <input
                    type='text'
                    className='form-control'
                    name='serieDocumento'
                    placeholder='Ej: F001'
                    value={datosManual.serieDocumento}
                    onChange={handleManualChange}
                    maxLength={4}
                    style={{ textTransform: 'uppercase' }}
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label'>Número</label>
                  <input
                    type='text'
                    className='form-control'
                    name='numeroDocumento'
                    placeholder='Ej: 0000456'
                    value={datosManual.numeroDocumento}
                    onChange={handleManualChange}
                    maxLength={8}
                  />
                </div>
              </Col>
            </Row>
          </div>
        ) : documentoInfo ? (
          <Sections.DocumentoInfoSection documentoInfo={documentoInfo} />
        ) : (
          <Sections.ListaDocumentosSection
            idSocio={mainFormData._idSocio}
            clickSeleccionarDocumentoClick={clickSeleccionarDocumentoClick}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
        {documentoInfo && !modoManual && (
          <Button color='warning' onClick={handleVolver}>
            Cambiar
          </Button>
        )}
        <Button onClick={handleSubmit} disabled={!puedeGuardar}>
          Procesar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(HistorialVentasModal)
